import { useMemo } from "react";
const useAvailableLocations = (filterGridLocationItem, filterValuesItem) => {
  return useMemo(() => {
    if (!filterValuesItem || !filterGridLocationItem) {
      return [];
    }
    const locations = filterValuesItem.data[filterGridLocationItem.key];
    return locations.filter((location) => location.available);
  }, [filterGridLocationItem, filterValuesItem]);
};
export {
  useAvailableLocations
};
